<template>
  <article>
    <section class="xbed-sub-title">
      <span>门店详情</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>渠道列表</BreadcrumbItem>
        <BreadcrumbItem>关联管理</BreadcrumbItem>
        <BreadcrumbItem>门店详情</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道门店信息" name="channelInfo" ref="channelInfo">
        <Form label-position="left" class="hotel-info" :label-width="110">
          <FormItem label="渠道门店ID：" prop="title">
            <span>{{ channelInfo.channelHotelId }}</span>
          </FormItem>
          <FormItem label="渠道门店名称：" prop="title">
            <span>{{ channelInfo.channelHotelName }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="xbed门店信息" name="xbedHotelInfo" ref="xbedHotelInfo">
        <Form label-position="left" class="hotel-info" :label-width="110">
          <FormItem label="xbed门店ID：" prop="title">
            <span>{{ xbedHotelInfo.xbedHotelId }}</span>
          </FormItem>
          <FormItem label="渠道门店名称：" prop="title">
            <span>{{ xbedHotelInfo.xbedHotelName }}</span>
          </FormItem>
          <FormItem label="主要联系人：" prop="title">
            <span>{{ xbedHotelInfo.contactName }}</span>
          </FormItem>
          <FormItem label="主要联系电话：" prop="title">
            <span>{{ xbedHotelInfo.contactPhone }}</span>
          </FormItem>
          <FormItem label="省份：" prop="title">
            <span>{{ xbedHotelInfo.province }}</span>
          </FormItem>
          <FormItem label="城市：" prop="title">
            <span>{{ xbedHotelInfo.city }}</span>
          </FormItem>
          <FormItem label="区域：" prop="title">
            <span>{{ xbedHotelInfo.district }}</span>
          </FormItem>
          <FormItem label="备注：" prop="title">
            <span>{{ xbedHotelInfo.remark }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="门店房型列表" name="roomTypeList" ref="roomTypeList" style="margin-left: 1px">
        <section>
          <Form :model="roomTypeList.form" @submit.native.prevent="preventSubmit" inline>
            <FormItem prop="keyword" label="房型名称：" :label-width="84">
              <Input type="text" v-model="roomTypeList.form.keyword" placeholder="查询关键字"></Input>
            </FormItem>
            <!-- <FormItem prop="isPackaged" label="打包状态：" :label-width="84">
              <Select v-model="roomTypeList.form.isPackaged" filterable>
                <Option value="S00">全部</Option>
                <Option value="S01">已打包</Option>
                <Option value="0">未打包</Option>
              </Select>
            </FormItem> -->
            <FormItem prop="roomTypeQuery">
              <Button type="primary">查询</Button>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="openAddModal">新增房型</Button>
            </FormItem>
          </Form>
          <Table stripe :loading="roomTypeList.loading" height="450" :columns="roomTypeList.columns" :data="roomTypeList.data"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="roomTypeList.count" :current="roomTypeList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
        </section>
      </TabPane>
    </Tabs>

    <Modal v-model="addRoomType.display" ref="addRoomTypeModal" :loading="true" title="新增渠道门店房型" @on-ok="prepareAddRoomType" ok-text="新增" cancel-text="取消">
      <Form @submit.native.prevent="preventSubmit" :label-width="84">
        <FormItem label="房型名称：" prop="name">
          <Input type="text" v-model="addRoomType.name"></Input>
        </FormItem>
        <FormItem label="缓冲房量：" prop="amount">
          <Input type="text" v-model="addRoomType.amount"></Input>
        </FormItem>
      </Form>
    </Modal>

  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.hotelId = Utils.getUrlParameterByName("hotelId");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      channelId: 4,
      currTabName: "channelInfo",
      channelInfo: {
        channelHotelId: "",
        channelHotelName: ""
      },
      xbedHotelInfo: {
        xbedHotelId: "",
        xbedHotelName: "",
        contactPhone: "",
        province: "",
        city: "",
        district: "",
        remark: ""
      },
      roomTypeList: {
        form: {
          keyword: "",
          isPackaged: "S00"
        },
        columns: [
          {
            title: "ID",
            key: "roomTypeId",
            align: "center",
            width: 150,
            fixed: "left"
          },
          {
            title: "房型名称",
            key: "name",
            align: "center",
            width: 350
          },
          {
            title: "打包数量",
            key: "packageRoomCount",
            align: "center",
            width: 200
          },
          {
            title: "缓冲房量",
            key: "bufferCount",
            align: "center",
            width: 200
          },
          {
            title: "操作",
            align: "center",
            width: 240,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if (this.$router) {
                          this.$router.push({
                            path: "elongChannelRoomTypeDetail",
                            query: { roomTypeId: params.row.roomTypeId }
                          });
                        } else {
                          window.open(
                            `#/Ota/Ota/xbedChannelRoomTypeDetail?roomTypeId=${params.row.roomTypeId}`
                          );
                        }
                      }
                    }
                  },
                  "编辑打包"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定删除 ${
                              params.row.roomTypeId
                            } - ${
                              params.row.name
                            } 吗？\n已打包的房间将重新单独售卖`;
                            return modalH(
                              "div",
                              {
                                style: {
                                  fontSize: "16px"
                                }
                              },
                              modalText
                            );
                          },
                          onOk: () => {
                            // this.removeRoomType(params.index);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      },
      addRoomType: {
        display: false,
        name: '',
        amount: ''
      }
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryHotelData();
    },
    queryHotelData() {
      if (this.currTabName !== "roomTypeList") {
        this.queryHotelBaseInfo();
      } else {
        this.queryHotelRoomTypeList();
      }
    },
    async queryHotelBaseInfo() {
      let resp = (await this.findHotel(this.token, this.env)).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      Object.keys(resp).map(key => {
        this.channelInfo.hasOwnProperty(key)
          ? (this.channelInfo[key] = resp[key])
          : "";
        this.xbedHotelInfo.hasOwnProperty(key)
          ? (this.xbedHotelInfo[key] = resp[key])
          : "";
      });
    },
    findHotel(token, env) {
      return API.omsAPI[env].ota.findHotel(this.hotelId, token);
    },
    async queryHotelRoomTypeList(){
      this.roomTypeList.loading = true;
      const resp = (await this.getRoomTypeList(
        this.roomTypeList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      resp.result.forEach( roomTypeItem => {
        roomTypeItem.packageRoomCount >= 0 ? "" : roomTypeItem.packageRoomCount = 0;
      });
      this.roomTypeList.data = resp.result;
      this.roomTypeList.count = resp.count;
      this.roomTypeList.loading = false;
    },
    getRoomTypeList(roomTypeList, token, env) {
      // let isPackaged = this.roomTypeList.form.isPackaged=="S00" ? "" : this.roomTypeList.form.isPackaged;
      let params = {
        channelHotelId: this.hotelId,
        page: roomTypeList.page,
        rows: roomTypeList.pageSize,
        status: 'S01',
        name: this.roomTypeList.form.keyword,
      }
      return API.omsAPI[env].ota.getRoomTypeList(params, token);
    },
    changePage(pageIndex) {
      this.roomTypeList.page = pageIndex;
    },
    changePageSize(pageSize) {
      this.roomTypeList.page = 1;
      this.roomTypeList.pageSize = pageSize;
    },
    // 添加房型
    openAddModal() {
      this.addRoomType.display = true;
    },
    async prepareAddRoomType() {
      if (this.addRoomType.name.length==0) {
        this.$Notice.error({
          title: "添加房型失败",
          desc: "房型名称不能为空！"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      } else if (this.addRoomType.name.length>50) {
        this.$Notice.error({
          title: "添加房型失败",
          desc: "房型名称不能超过50字！"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }
      // let resp = (await API.omsAPI[this.env].ota.addRoomType(
      //   this.channelId,
      //   this.hotelId,
      //   this.newRoomTypeName,
      //   this.username,
      //   this.token
      // )).data;

      // if (resp.retCode) {
      //   // 错误警告
      //   this.$refs.addHotelModal.buttonLoading = false;
      //   this.$Notice.error({
      //     title: "添加房型失败",
      //     desc: resp.msg
      //   });
      // } else {
      //   this.$Notice.success({
      //     title: "添加房型成功"
      //   });
      //   this.modalDisplay = false;
      //   this.refreshTable();
      //   this.resetAddModalData();
      // }
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.hotel-info {
  padding: 20px;
  span {
    line-height: 34px;
    font-size: 14px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/ota/elong-hotel-detail.vue